export default __webpack_public_path__ + "static/media/masters_thumb.867937db.jpg";